import iconVK from 'assets/image/share/vk.png';
import iconZen from 'assets/image/share/zen.png';
import iconTG from 'assets/image/share/telegram.png';
import iconYandex from 'assets/image/share/yandex.png';
import iconRutube from 'assets/image/share/rutube.png';
import iconOK from 'assets/image/share/odnoklas.png';
import iconStream from 'assets/image/share/stream.png';
import iconZvuk from 'assets/image/share/zvuk.png';
import iconLitRes from 'assets/image/share/iconLitRes.png';
import iconMax from 'assets/image/share/max.png';
import { FC } from 'react';
import styles from './social-networks.module.scss';

export const SocialNetworks: FC = () => {
  return (
    <div className={styles.socials}>
      <aside className={styles.networkradio}>
        <p className={styles.networkradio__text}>Радио Звезда на других платформах:</p>
        <section className={styles.networkradio__wrap}>
          <a href="https://max.ru/radiozvezda" target="_blank">
            <img src={iconMax.src} height={30} width={30} alt="Иконка MAX" />
          </a>
          <a href="https://t.me/radiozvezda" target="_blank">
            <img src={iconTG.src} height={30} width={30} alt="Иконка телеграмма" />
          </a>
          <a href="https://vk.com/radiozvezda" target="_blank">
            <img src={iconVK.src} height={30} width={30} alt="Иконка Вконтакте" />
          </a>
          <a href="https://ok.ru/radiozvezda" target="_blank">
            <img src={iconOK.src} height={30} width={30} alt="Иконка Вконтакте" />
          </a>
          <a href="https://dzen.ru/radiozvezda" target="_blank">
            <img src={iconZen.src} height={30} width={30} alt="Иконка Зена" />
          </a>
          <a href="https://rutube.ru/channel/24671023/" target="_blank">
            <img src={iconRutube.src} height={30} width={30} alt="Иконка Рутуба" />
          </a>
          <a href="https://music.yandex.ru/label/5054349" target="_blank">
            <img src={iconYandex.src} height={30} width={30} alt="Иконка Яндекс Музыки" />
          </a>
          <a href="https://soundstream.media/channel/radio-zvezda-2" target="_blank">
            <img src={iconStream.src} height={30} width={30} alt="Иконка Яндекс Музыки" />
          </a>
          <a
            href="https://zvuk.com/search?query=%D1%80%D0%B0%D0%B4%D0%B8%D0%BE%20%D0%B7%D0%B2%D0%B5%D0%B7%D0%B4%D0%B0"
            target="_blank"
          >
            <img src={iconZvuk.src} height={30} width={30} alt="Иконка Яндекс Музыки" />
          </a>
          <a href="https://www.litres.ru/author/radio-zvezda-32575255/" target="_blank">
            <img src={iconLitRes.src} height={30} width={30} alt="Иконка Яндекс Музыки" />
          </a>
        </section>
      </aside>
      <aside className={styles.networkanalytics}>
        <p className={styles.networkanalytics__text}>
          Звезда Аналитика на других платформах:
        </p>
        <section className={styles.networkanalytics__wrap}>
          <a href="https://max.ru/zvezda_analytics" target="_blank">
            <img src={iconMax.src} height={30} width={30} alt="Иконка MAX" />
          </a>
          <a href="https://t.me/zvezda_analytics" target="_blank">
            <img src={iconTG.src} height={30} width={30} alt="Иконка телеграмма" />
          </a>
          <a href="https://vk.com/zvezda_analytics" target="_blank">
            <img src={iconVK.src} height={30} width={30} alt="Иконка Вконтакте" />
          </a>
          <a href="https://ok.ru/zvezdaanalytics" target="_blank">
            <img src={iconOK.src} height={30} width={30} alt="Иконка ОК" />
          </a>
          <a href="https://dzen.ru/zvezda_analytics" target="_blank">
            <img src={iconZen.src} height={30} width={30} alt="Иконка Дзена" />
          </a>
          <a href="https://rutube.ru/channel/29607180/" target="_blank">
            <img src={iconRutube.src} height={30} width={30} alt="Иконка Рутуба" />
          </a>
          <a
            href="https://music.yandex.ru/album/24818839?dir=desc&activeTab=about"
            target="_blank"
          >
            <img src={iconYandex.src} height={30} width={30} alt="Иконка Яндекс Музыки" />
          </a>
          <a href="https://soundstream.media/playlist/zvezda-analitika" target="_blank">
            <img src={iconStream.src} height={30} width={30} alt="Иконка Саундстрим" />
          </a>
          <a href="https://zvuk.com/podcast/28570309" target="_blank">
            <img src={iconZvuk.src} height={30} width={30} alt="Иконка Звук" />
          </a>
        </section>
      </aside>
    </div>
  );
};
